import {Component, Input, OnInit} from '@angular/core';
import {ClrDatagridModule, ClrDatagridSortOrder, ClrIconModule, ClrModalModule} from "@clr/angular";
import {NgxExtendedPdfViewerModule} from "ngx-extended-pdf-viewer";
import {Components, Files} from "../../../../_shared/interfaces";
import {AlertService, FileStoreService, IAlertType} from "../../../../_shared/services";
import {ActivatedRoute} from "@angular/router";
import { getTenantStorage } from '../../../../_shared/utils/tenant-context';

import { ClarityIcons, timesCircleIcon } from "@cds/core/icon";
import { saveAs } from "file-saver";

import { environment as env } from "../../../../../environments/environment";
import { filesBaseUrl } from "../../../../_shared/utils/rest-url";
import {NgIf} from "@angular/common";
import {UploadComponent} from "../../../../core/upload/upload.component";
import {TranslocoDirective} from "@jsverse/transloco";

@Component({
  selector: 'app-order-details-documents',
  standalone: true,
  imports: [
    ClrDatagridModule,
    ClrIconModule,
    NgxExtendedPdfViewerModule,
    NgIf,
    ClrModalModule,
    UploadComponent,
    TranslocoDirective
  ],
  templateUrl: './order-details-documents.component.html',
  styleUrl: './order-details-documents.component.sass'
})
export class OrderDetailsDocumentsComponent implements OnInit {
  components: Components[] = [];
  ordersFiles: Files[] = [];
  showPdf = false;
  showFileUpload = false;
  modalContent: string = '';
  modalUrl: string = '';
  loading: boolean = true;
  descSort = ClrDatagridSortOrder.DESC;

  private filesDirectory = filesBaseUrl();

  @Input() projectId: string = '';
  @Input() orderId: number = 0;
  @Input() jobId: number = 0;

  constructor(
    private alertDispatcher: AlertService,
    private fileService: FileStoreService,
  ) {
    ClarityIcons.addIcons(timesCircleIcon)
  }

  ngOnInit() {
    this.getFilesSet([4,20,55,60,80], this.projectId);
  }

  showModal(fileId: string) {
    const phmToken = getTenantStorage('access_token');
    this.modalUrl = `${this.filesDirectory}/download_file?file_id=${fileId}&token=${phmToken}`;
    this.showPdf = true;
  }

  closeModal(state: boolean) {
    this.showFileUpload = state;
    this.loading = true;
    this.getFilesSet([4,20,55,60,80], this.projectId);
  }

  showFileUploader() {
    this.showFileUpload = true;
  }

  private getFilesSet(docType: number[], projectId: string) {
    this.fileService.getFilesSet(docType, projectId, 0, this.orderId).subscribe({
      next: data => {
        if (!data || !data.object || data.object.length === 0) {
          this.ordersFiles = [];
          this.alertDispatcher.alertConfig.message = 'Keine Dateien gefunden!';
          this.alertDispatcher.alertConfig.clrAlertType = IAlertType.WARNING;
          return;
        }
        this.ordersFiles = data.object;
        this.descSort = ClrDatagridSortOrder.DESC;
      },
      complete: () => {
        this.loading = false;
      },
      error: () => {
        return}
    })
  }

  deleteFile(fileId: string, fileName: string) {
    if (confirm('Wollen Sie die Datei ' + fileName + ' wirklich löschen?\nDiese Aktion kann nicht rückgängig gemacht werden!')) {
      this.fileService.deleteFile(fileId)
        .subscribe({
          next: () => {
            this.ordersFiles = this.ordersFiles.filter(file => file.id !== fileId);
            this.alertDispatcher.alertConfig.message = 'Datei ' + fileName + ' wurde gelöscht. ';
            this.alertDispatcher.alertConfig.clrAlertType = IAlertType.DANGER;
          },
          complete: () => {
            this.getFilesSet([4,20,55,60,80], this.projectId);
          },
          error: () => {
            return
          }
        })
    }
  }

  loadFile(fileId: string, fileName: string) {
    if (confirm('Wollen Sie die Datei ' + fileName + ' herunterladen?')) {
      this.fileService.downloadFile(fileId)
        .subscribe({
          next: data => {
            if (!data) {
              this.alertDispatcher.alertConfig.message = 'Keine Datei gefunden!';
              this.alertDispatcher.alertConfig.clrAlertType = IAlertType.WARNING;
              return;
            }
            saveAs(data, fileName);
          },
          complete: () => {
            this.alertDispatcher.alertConfig.message = 'Datei ' + fileName + ' wurde heruntergeladen. ';
            this.alertDispatcher.alertConfig.clrAlertType = IAlertType.INFO;
          },
          error: () => {
            return
          }
        })
    }
  }
}
